import { PureComponent } from 'react'
import styled from 'glamorous'

import { div, $ } from 'utils'
import { Icon, HeaderRow, Loader } from 'components'

import Matching from './Matching'
import Original from './Original'

const Container = styled.div({
  width: '100%',
  height: '100%',
})

const HeaderContainer = styled.div({
  padding: '25px 30px 0 30px',
  borderBottom: '1px solid var(--borderColor)',
})

const BodyContainer = styled.div({
  padding: '25px 30px',
})

const ContentContainer = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
})

const PanelContainer = styled.div({
  position: 'absolute',
  bottom: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'white',
  zIndex: 1060,
  transform: 'translateY(100%)',
  animation: 'var(--animationSlideUp)',
}, ({ shown }) => !shown && ({
  animation: 'var(--animationSlideDown)',
}), 'BottomPanel')


class Results extends PureComponent {

  state = {
    shown: true
  }

  close = () => {
    this.setState({ shown: false })
    setTimeout(() => { this.props.closeBottomPanel() }, 500)
  }

  render() {
    const { type, matchType, results, source, loading, error } = this.props
    const { shown } = this.state
    if (loading) return $(Loader)

    return (
      $(PanelContainer, { shown },
        $(Container,
          $(HeaderContainer,
            $(HeaderRow, { label: matchType === 'match' ? 'Matching' : 'Identifying' },
              div({ onClick: this.close },
                $(Icon, { type: 'close', color: 'var(--lightGrey)' })
              )
            ),
          ),
          $(BodyContainer,
            $(ContentContainer,
              $(Original, { source, type }),
              $(Matching, { loading, results, matchType, error })
            )
          )
        )
      )
    )
  }
}

export default Results


// WEBPACK FOOTER //
// ./src/components/panels/MatchingResults/Results.js